var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmbrella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C7.44772 0 7 0.447715 7 1C7 1.02071 7.00063 1.04127 7.00187 1.06166C3.05465 1.55293 0 4.91974 0 9C0 9.55229 0.447715 10 1 10H7V13C7 14.6569 8.34315 16 10 16C11.6569 16 13 14.6569 13 13V12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V10H15C15.5523 10 16 9.55229 16 9C16 4.91974 12.9453 1.55293 8.99813 1.06166C8.99937 1.04127 9 1.02071 9 1C9 0.447715 8.55228 0 8 0ZM2.08296 8H8H13.917C13.441 5.16229 10.973 3 8 3C5.027 3 2.55904 5.16229 2.08296 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmbrella);
export default __webpack_public_path__ + "static/media/umbrella.b36ecd277e1ffd9999858d4d6fac6833.svg";
export { ForwardRef as ReactComponent };